export default {
  description:
    'Sube los documentos que necesitamos para verificar tu negocio. Los documentos obligatorios están marcados; los opcionales puedes agregarlos ahora o más tarde.',
  missing_one: 'Aún falta un documento obligatorio. Puedes continuar: este paso permanecerá abierto hasta que se suba.',
  missing_other:
    'Aún faltan {{count}} documentos obligatorios. Puedes continuar: este paso permanecerá abierto hasta que se suban.',
  buttons: {
    back: 'Atrás',
    next: 'Siguiente',
    finish_later: 'Terminar más tarde',
  },
};
